export default {
  AddOffer: 'Add offer',
  notFound: 'Page not found',
  OrderCancel: 'Order Cancel',
  UserRachedSource: 'User Rached Source',
  RequestStart: 'Request Start',
  TheSourceDestinationSelected: 'The source and destination are selected.',
  ThisCargoIsNotSupportedByFreight: 'This cargo is not supported by freight',
  AssignCommodity: 'Assign Commodity',
  AssignCar: 'Car Assign',
  ActiveLoads: 'Active loads',
  Accept: 'Accepted!',
  Active: 'Active',
  Confirmed: 'Confirmed',
  Current: 'Current',
  CustomerAccept: 'Customer Accept',
  CurrentLoads: 'Current loads',
  Currency: 'Currency',
  ChoseLatAndLong: 'Chose Lat and Long',
  Canceled: 'Canceled',
  Car: 'Car',
  CancelType: 'CancelType',
  CustomerConfirmed: 'Customer Confirmed',
  DestinationCity: 'Destination city',
  DestinationProvince: 'Destination province',
  CompanyApproval: 'Courier Approval',
  OriginAddress: 'Origin Address',
  OriginCity: 'Origin city',
  OriginProvince: 'Origin province',
  Details: 'Details',
  DestinationAddress: 'Destination Address',
  DeliveryService: 'Delivery Service',
  DateAndTimeOfRequest: 'Date And Time Of Request',
  EditCoordinates: 'Edit Coordinates',
  ExcessCost: 'Excess Cost',
  EndLoads: 'EndLoads',
  Download: 'Download',
  Transferee: 'Transferee',
  FinishService: 'Finish Service',
  Feedback: 'Feedback',
  CompletingSelectbox: 'Completing Select box',
  Driver: 'Driver',
  DriverTraining: 'Driver Training',
  DischargeDayPart: 'Discharge Day Part',
  ReachOrgin: 'Reach Orgin',
  Amount: '‌‌‌Base price',
  Brand: 'Courier Name',
  End: 'End',
  HeightMeter: 'Height(m)',
  ElevatorHasCargo: 'Elevator Has Cargo',
  BearingType: 'Bearing Type',
  Companylist: 'Courier list',
  CompleteProfile: 'Complete Profile',
  Cost: 'Cost',
  CarLoad: 'Car Load',
  CarModelFeature: 'Car Model Feature',
  Capacity: 'Capacity',
  Count: 'ٔNumber',
  CompanyName: 'Courier Name',
  CompanyDiscountAmount: 'Courier Discount Amount',
  CustomerName: 'Customer Name',
  CompanyFee: 'Courier Fee',
  CustomerMobile: 'Customer Mobile',
  Cars: 'Cars',
  CarCount: 'Car count',
  SmallCost: 'Cost',
  DistanceToLift: 'Distance To Lift',
  DisplayBearings: 'Display Bearings',
  DistanceFromEntranceDoorToCar: 'Distance from entrance door to car (m)',
  DelivererName: 'Name of the deliverer',
  Finish: 'Finish',
  BackToFinish: 'Revert finish',
  Floor: 'Floor',
  FreeAmount: 'Free Amount',
  Unit: 'Unit',
  UserRequestTime: 'User Request Time',
  TypeOfCargo: 'Type Of Cargo',
  TechnicalLaborer: 'Technical laborer',
  TransfereeName: 'Trasferee Name',
  LengthMeter: 'Length(m)',
  MobileDeliveryService: 'Mobile Delivery Service',
  Mobilereceiverdelivery: 'Mobile receiver delivery',
  MonetaryValue: 'Monetary (miliun)',
  LoadAppropriation: 'Load Appropriation',
  NewService: 'New Service',
  RegistTime: 'Regist Time',
  NumberOfWorkersWithoutEquipment: 'Number of workers without equipment',
  NewRequest: 'New Request',
  NextLevel: 'Next Level',
  CustomerOffer: 'Customer Offer',
  Orgin: 'Orgin',
  RequestEnabled: 'Request Enabled',
  Range: 'Range',
  Start: 'Start',
  BackToStart: 'Revert start',
  SelectCompany: 'Select Courier',
  ReachDestination: 'Reach Destination',
  Refrigerator: 'Refrigerator',
  RevertAccept: 'RevertAcceptDocument type',
  Instrument: 'Instrument',
  Items: 'Items',
  Loadsteps: 'Load Steps',
  Loads: 'Loads',
  Image: 'Image',
  PayableAmount: 'PayableAmount',
  Status: 'Status',
  Score: 'Score',
  StartEmployee: 'Start Employee',
  SelectSourceDestination: 'Select Source Destination',
  SelectRequiredItems: 'Select Required Items',
  StartLoading: 'Start loading',
  Successful: 'Successful',
  StartService: 'StartService',
  WebsiteDiscountAmount: 'Barbanet Discount Amount',
  websiteFee: 'Barbanet Fee',
  Worker: 'Worker',
  TV: 'TV',
  Destination: 'Destination',
  TotalAmount: 'TotalAmount',
  Mirror: 'Mirror and buffet',
  Laborer: 'Laborer',
  OperationWasSuccessfull: 'Operation Was Successfull',
  Offers: 'Offers',
  Plate: 'Plate',
  Package: 'Package',
  WeightTon: 'Weight(Ton)',
  WidthMeter: 'Width(m)',
  PriceUpdate: 'Price Update',
  DocumentType: 'Document type',
  ShipmentGeneralInformationEditedSuccessfully:
    'Order general information edited successfully',
  CargoParameters: 'Cargo parameters',
  GeographicalAttributes: 'Geographical attributes',
  LoadingAddress: 'Loading address',
  DischargeAddress: 'Discharge address',
  EstimatedDistance: 'Estimated distance',
  EstimatedDuration: 'Estimated duration',
  InIntercityFurnitureCityOfOriginAndDestinationShouldNotBeTheSame:
    'In intercity furniture, the city of origin and destination should not be the same',
  InIntercityCargoCityOfOriginAndDestinationShouldNotBeTheSame:
    'In intercity cargo, the city of origin and destination should not be the same',
  InIUrbanFurnitureCityOfOriginAndDestinationShouldBeTheSame:
    'In urban furniture, the city of origin and destination should be the same',
  InUrbanCargoCityOfOriginAndDestinationShouldBeTheSame:
    'In urban cargo, the city of origin and destination should be the same',
  CompleteLoadingLocationInformation: 'Complete loading location information',
  CompleteDischargeLocationInformation:
    'Complete discharge location information',
  CompleteOriginAddressInformation: 'Complete origin address information',
  CompleteDestinationAddressInformation:
    'Complete destination address information',
  OriginPlate: 'Origin plate',
  DestinationPlate: 'Destination plate',
  OriginFloor: 'Origin floor',
  DestinationFloor: 'Destination floor',
  OriginDistanceFromEntranceDoorToCar:
    'Origin Distance from entrance door to car',
  DestinationDistanceFromEntranceDoorToCar:
    'Destination Distance from entrance door to car',
  ChooseOriginAndDestinationOnMap: 'Choose origin and destination on map',
  ShipmentCarInformationEditedSuccessfully:
    'Order car information edited successfully',
  ThisModelOfCarCanNotBeUseForThisOrderJustDeleteAllowed:
    'This model of car can not be use for this order, just delete allowed',
  TransportTechnicalForceInformationWasSuccessfullyEdited:
    'Transport technical force information was successfully edited',
  ShipmentItemListEditedSuccessfully: 'Order item list edited successfully',
  NoFeedbackHasBeenRecordedForThisShipmentYet:
    'No feedback has been recorded for this order yet',
  RecordFeedback: 'Record feedback',
  NoResponseHasBeenRecordedForThisFeedbackYet:
    'No response has been recorded for this feedback yet',
  RecordResponse: 'Record response',
  NoTechnicalForceAddedYet: 'No technical force added yet',
  YouCantChooseSimpleEmployeeForShipmentsWitchHasCar:
    "You can't choose simple employee for orders witch has car, Please remove simple employee(s)",
  YouShouldSelectAtLeastOneTechnicalForceForCarFreeShipments:
    'You should select at least one technical force for car-free orders',
  TemplateCreationTime: 'Template creation time',
  DraftCreationTime: 'Draft creation time',
  furnitureWithCar: 'Furniture with car',
  previousLevel: 'Previous level',
  addThisCarIsImpossible: 'Add this car is impossible',
  minimumCountForCar_Is_person:
    'Minimum count of laborer for {carName} is {count}',
  maximumCountForCar_Is_person:
    'Maximum count of laborer for {carName} is {count}',
  simpleLaborer: 'Simple laborer',
  furnitureType: 'Furniture type',
  withCar: 'With car',
  withoutCar: 'Without car',
  expensiveItems: 'Expensive Items',
  dateAndTime: 'Date and time',
  furnitureDate: 'Furniture date',
  furnitureHour: 'Furniture hour',
  loadDate: 'Load date',
  loadHour: 'Load hour',
  dischargeDate: 'Discharge date',
  dischargeTime: 'Discharge time',
  selectCompany: 'Select courier',
  pricing: 'Pricing ...',
  atLeastSelectOneCompany: 'At least select one courier',
  orderCreatedSuccessfully: 'Order created successfully',
  creatingOrder: 'Creating order ...',
  noCompanyFoundBasedOnYourRequest: 'No courier found based on your request',
  atLeastSelectOneCar: 'At least select one car',
  cargoWeight: 'Cargo weight',
  cargoLength: 'Cargo length',
  cargoWidth: 'Cargo width',
  cargoHeight: 'Cargo height',
  resumeOrderRegistration: 'Resume order registration',
  saveAsDraft: 'Save as draft',
  draftSavedSuccessfully: 'Draft saved successfully',
  editDraft: 'Edit draft',
  draftEditedSuccessfully: 'Draft edited successfully',
  revertAssign: 'Revert assign',
  cancelReason: 'Cancel reason',
  cancelDescription: 'Cancel description',
  distance: 'Distance',
  startWithoutAssignDriver: 'Start without assign driver',
  revertStartWithoutAssignDriver: 'Revert start without assign driver',
  assignDriver: 'Assign driver',
  revertAssignDriver: 'Revert assign driver',
  customerFeedback: 'Customer feedback',
  loadForwardSteps: 'Load forward steps',
  loadRevertSteps: 'Load revert steps',
  draftType: 'Draft type',
  draftRange: 'Draft range',
  templateType: 'Template type',
  templateRange: 'Template range',
  tariff: 'Tariff',
  nonTariff: 'Non-tariff',
  driverFullName: 'Driver full name',
  driverNationalId: 'Driver national ID',
  diverSuggestedAmount: 'Driver suggested amount',
  vehicleSmartCardNumber: 'Vehicle smart number',
  vehiclePlate: 'Vehicle plate',
  iran: 'Iran',
  originWeightOfWeighbridge: 'Origin weight of weighbridge',
  destinationWeightOfWeighbridge: 'Destination weight of weighbridge',
  originWeighbridgeReceipt: 'Origin weighbridge receipt',
  destinationWeighbridgeReceipt: 'Destination weighbridge receipt',
  courierTariffPricing: 'Courier tariff pricing',
  courierAuctionPricing: 'Courier',
  webServicePricing: 'Web service pricing',
  driverAuctionPricing: 'Driver auction pricing',
  registerOriginWeighBridge: 'Register origin weighbridge',
  registerDestinationWeighBridge: 'Register destination weighbridge',
  successfulOriginWeighBridgeUpdate: 'Register origin weighbridge',
  successfulDestinationWeighBridgeUpdate: 'Register destination weighbridge'
}
